import { createFileRoute } from "@tanstack/react-router";
import { ProcedurePage } from "@/components/site/ProcedurePage";
import { getProcedure } from "@/content/inner-pages";
import { pageHead } from "@/lib/seo";

const data = getProcedure("mommy-makeover-foz-do-iguacu");

export const Route = createFileRoute("/especialidades/mommy-makeover-foz-do-iguacu")({
  head: () => pageHead({ title: data.metaTitle, description: data.metaDescription, path: data.path }),
  component: () => <ProcedurePage data={data} />,
});
